import request from '@/utils/request'

// 查询订单评价列表
export function listComment(data) {
  return request({
    url: '/sysOrderComment/list',
    method: 'post',
    data,
  })
}

// 查询订单评价详细
export function getComment(id) {
  return request({
    url: '/system/comment/' + id,
    method: 'get',
  })
}

// 新增订单评价
export function addComment(data) {
  return request({
    url: '/system/comment',
    method: 'post',
    data: data,
  })
}

// 修改订单评价
export function updateComment(data) {
  return request({
    url: '/sysOrderComment/update',
    method: 'post',
    data: data,
  })
}

// 删除订单评价
export function delComment(id) {
  return request({
    url: '/sysOrderComment/delete/?id=' + id,
    method: 'get',
  })
}
